<template>
  <BlockLink
    v-if="!!mediaUrl && !!cardUrl"
    :label="cardUrlTitle"
    :link="cardUrl"
    class="media image"
  >
    <div :style="{ 'background-color': bgColor }" class="media__container">
      <WidgetLoadingIndicator :is-loaded="isLoaded" />
      <ClientOnly>
        <NuxtImg
          v-show="!!resizedImage"
          :alt="altText"
          :class="{ loaded: isLoaded }"
          :src="resizedImage"
          :style="`object-fit: ${fit}; object-position: ${focusInPercent}`"
          loading="lazy"
          @load="onLoadedImage"
        />
      </ClientOnly>
    </div>
  </BlockLink>
  <div v-else-if="!!mediaUrl" class="media image">
    <div :style="{ 'background-color': bgColor }" class="media__container">
      <WidgetLoadingIndicator :is-loaded="isLoaded" />
      <ClientOnly>
        <NuxtImg
          v-show="!!resizedImage"
          :alt="altText"
          :class="{ loaded: isLoaded }"
          :src="resizedImage"
          :style="`object-fit: ${fit};`"
          loading="lazy"
          @load="onLoadedImage"
        />
      </ClientOnly>
    </div>
  </div>
  <div v-else class="media image">
    <div class="media__container">
      <div class="no-media">
        <Icon name="fa6-solid:image" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Media } from '~/composables/useMedia'

const props = withDefaults(
  defineProps<{
    useAspect?: boolean
    cardUrl?: string
    cardUrlTitle?: string
    bgColor?: string
    fit?: string
    media?: Media
    maxHeight?: number
    maxWidth?: number
    quality?: number
  }>(),
  {
    useAspect: false,
    cardUrl: '',
    cardUrlTitle: '',
    bgColor: 'transparent',
    fit: 'cover',
    media: () => ({}),
    maxHeight: 0,
    maxWidth: 960,
    quality: 65,
  },
)

const {
  isLoaded,
  altText,
  mediaUrl,
  resizedImage,
  onLoadedImage,
  focusInPercent,
} = useMedia(toRefs(props))

watch(
  () => props.media,
  (val, prev) => {
    if (val.filename !== prev.filename) {
      isLoaded.value = false
    }
  },
)
</script>

<style lang="less" scoped>
.media.image {
  .media__container {
    img {
      .block();
      .absolute();

      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      object-fit: cover;
      transform: none;
      margin: 0 auto;
      opacity: 0;
      transition: opacity 0.8s;

      &.loaded {
        opacity: 1;
      }
    }

    .no-media {
      .absolute();
      .font-3xl();

      color: @color-text-muted;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
@media print {
  .media.image {
    .media__container {
      img {
        opacity: 1;
      }
    }
  }
}
</style>
